import type { RedcatAnalyticsStore } from '../types/store';
import type { PaymentEventBase } from '../types/payment';
import { PaymentTrackEventName } from '../types/payment';
import type { PaymentTrackEvent } from '../types/events/track';
import { paymentEventProperties } from './paymentEventProperties';

export const trackPaymentTimeout = (
  track: RedcatAnalyticsStore['track'],
  args: PaymentEventBase,
) => {
  const event: PaymentTrackEvent = {
    name: PaymentTrackEventName.PaymentTimeout,
    properties: paymentEventProperties(args),
  };

  track(event);
};
